import { anatomyToVector } from "./index6.js";
import { getInnerLoadSide } from "./index18.js";
import { Vector3 } from "three";
var _vectorA = new Vector3();
var _vectorB = new Vector3();
var _cross = new Vector3();
function hasBoneAt({ bone, right, start, innerLoad, outerLoad }) {
	const joint = bone.joints[start ? 0 : 1];
	anatomyToVector(bone, _vectorA);
	const otherBones = joint.bones.filter((b) => b !== bone);
	for (const b of otherBones) {
		anatomyToVector(b, _vectorB);
		const bFacesBone = bone.joints.includes(b.joints[1]);
		if (start && bFacesBone) _vectorB.negate();
		_cross.crossVectors(_vectorA, _vectorB);
		const isRight = _cross.y < 0;
		if (!right === isRight) continue;
		if (innerLoad === void 0 && outerLoad === void 0) return true;
		else {
			const inLoadIndex = getInnerLoadSide(bFacesBone, start, isRight);
			const outLoadIndex = inLoadIndex ? 0 : 1;
			const inPass = innerLoad === void 0 ? true : innerLoad === b.loads[inLoadIndex];
			const outPass = outerLoad === void 0 ? true : outerLoad === b.loads[outLoadIndex];
			if (inPass && outPass) return true;
			break;
		}
	}
	return false;
}
export { hasBoneAt };

//# sourceMappingURL=index20.js.map